import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import { useNavigate, useParams } from "react-router-dom";

const UpdateTemplate = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [catalogList, setCatalogList] = useState([]);
    const [htmlDocList, setHtmlDocList] = useState([]);
    const [htmlDocZipList, setHtmlDocZipList] = useState([]);
    const [selectedCatalogId, setSelectedCatalogId] = useState("");
    const [selectedHtmlDocId, setSelectedHtmlDocId] = useState("");
    const [selectedHtmlDocZipId, setSelectedHtmlDocZipId] = useState("");
    const [message, setMessage] = useState("");

    // Function to get cookie by name
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null; // Return null if cookie not found
    };

    const token = getCookie("token");
    const userid = getCookie("userid");

    useEffect(() => {
        const fetchData = async () => {
            // Fetch template details to update
            try {
                const response = await axios.post(
                    'https://api.dqr-display-tms.eventum.co.in/api/DefaultTemplateOperation/Get',
                    { id: Number(id) },
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid || '10002',
                            'X-Authorization': token,
                            'Content-Type': 'application/json-patch+json'
                        }
                    }
                );

                if (response.data && response.data.isresponse && response.data.data.length > 0) {
                    const template = response.data.data[0];
                    setSelectedCatalogId(template.catalogid);
                    setSelectedHtmlDocId(template.htmldocid);
                    setSelectedHtmlDocZipId(template.htmldoczipid);
                }
            } catch (error) {
                console.error("Error fetching template details:", error);
            }

            // Fetch Catalogs
            try {
                const catalogResponse = await axios.get(
                    'https://api.dqr-display-tms.eventum.co.in/api/CatalogOperation/GetDistinct/catalogname',
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid || '10002',
                            'X-Authorization': token,
                        }
                    }
                );
                if (catalogResponse.data && catalogResponse.data.isresponse) {
                    setCatalogList(catalogResponse.data.data);
                }
            } catch (error) {
                console.error("Error fetching Catalogue names:", error);
            }

            // Fetch HTML Documents
            try {
                const htmlDocResponse = await axios.get(
                    'https://api.dqr-display-tms.eventum.co.in/api/HtmlDocOperation/GetDistinct/name',
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid || '10002',
                            'X-Authorization': token,
                        }
                    }
                );
                if (htmlDocResponse.data && htmlDocResponse.data.isresponse) {
                    setHtmlDocList(htmlDocResponse.data.data);
                }
            } catch (error) {
                console.error("Error fetching HTML document names:", error);
            }

            // Fetch HTML Doc Zip Names
            try {
                const htmlDocZipResponse = await axios.get(
                    'https://api.dqr-display-tms.eventum.co.in/api/HtmlDocZipOperation/GetDistinct/name',
                    {
                        headers: {
                            'accept': 'text/plain',
                            'UserId': userid || '10002',
                            'X-Authorization': token,
                        }
                    }
                );
                if (htmlDocZipResponse.data && htmlDocZipResponse.data.isresponse) {
                    setHtmlDocZipList(htmlDocZipResponse.data.data);
                }
            } catch (error) {
                console.error("Error fetching HTML Doc Zip names:", error);
            }
        };

        fetchData();
    }, [id, token, userid]);

    const handleSubmit = async () => {
        try {
            const data = {
                catalogid: Number(selectedCatalogId) === 0 ? -1 : Number(selectedCatalogId),
                htmldocid: Number(selectedHtmlDocId) === 0 ? -1 : Number(selectedHtmlDocId),
                htmldoczipid: Number(selectedHtmlDocZipId) === 0 ? -1 : Number(selectedHtmlDocZipId),
                id: Number(id)
            };

            const response = await axios.post(
                'https://api.dqr-display-tms.eventum.co.in/api/DefaultTemplateOperation/Update',
                data,
                {
                    headers: {
                        'accept': 'text/plain',
                        'UserId': userid || '10002',
                        'X-Authorization': token,
                        'Content-Type': 'application/json-patch+json'
                    }
                }
            );

            if (response.data && response.data.isresponse) {
                setMessage("Template updated successfully!");
                setTimeout(() => {
                    navigate("/default-template");
                }, 2000);
            } else {
                setMessage(response.data.errormsg || "Failed to update template.");
            }
        } catch (error) {
            console.error("Error updating template:", error);
            setMessage("Error submitting data.");
        }
    };

    return (
        <>
            <Menu />
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>Update Template</h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card card-info">
                                        <div className="card-header">
                                            <h3 className="card-title">Update Selection Form</h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Catalogue Name</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedCatalogId}
                                                            onChange={(e) => setSelectedCatalogId(e.target.value)}
                                                        >
                                                            <option value="">-- Select Catalogue --</option>
                                                            <option value="-1">null</option>
                                                            {catalogList && catalogList.length > 0 && catalogList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>HTML Document Name</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedHtmlDocId}
                                                            onChange={(e) => setSelectedHtmlDocId(e.target.value)}
                                                        >
                                                            <option value="">-- Select HTML Document --</option>
                                                            <option value="-1">null</option>
                                                            {htmlDocList && htmlDocList.length > 0 && htmlDocList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>HTML Doc Zip Name</label>
                                                        <select
                                                            className="form-control"
                                                            value={selectedHtmlDocZipId}
                                                            onChange={(e) => setSelectedHtmlDocZipId(e.target.value)}
                                                        >
                                                            <option value="">-- Select HTML Doc Zip --</option>
                                                            <option value="-1">null</option>
                                                            {htmlDocZipList && htmlDocZipList.length > 0 && htmlDocZipList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button type="button" className="btn btn-info" onClick={handleSubmit}>Update</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {message === "Template updated successfully!" && (
                <SuccessMessage message={message} />
            )}

            {message && message !== "Template updated successfully!" && (
                <FailedMessage message={message} />
            )}
        </>
    );
};

export default UpdateTemplate;
